import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gffqu8d96t: FaireBrandEntity = {
  token: "b_gffqu8d96t",
  type: "brand",
  name: "Lorabees",
  avatarUrl:
    "https://cdn.faire.com/fastly/6480e9e67fba15df39fcb3e58a871b9ae81114fafa2c3bb79f1af3c480ae5dbb.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/31d1fc20d205decb638273fc4db8b394a8ffbe9f9427e7b8881e3c518a964c2e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6480e9e67fba15df39fcb3e58a871b9ae81114fafa2c3bb79f1af3c480ae5dbb.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/31d1fc20d205decb638273fc4db8b394a8ffbe9f9427e7b8881e3c518a964c2e.jpeg",
  location: "Poynette, WI, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 108,
  isTopShop: true,
  isInsider: true,
  description:
    "Lorabees was started by two ambitious best friends, with a strong background in design, home decor, and a love of creating high quality products using fragrances that make your soul happy! We are a women owned company, based in Wisconsin, that hand crafts 100% soy candles, with cotton, lead-free wicks and clean scents. Our home fragrance line includes our candles, melts, and home fragrance sprays. Our bath & body line is growing, and currently includes women's and men's perfumes, hand lotions, goat milk body lotions, bubble bath, and bath salts, to name a few. Our customer service, quality, and creative packaging set us apart from the rest! We have several candle lines that will fit the style of any shop. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:58.525Z",
    importedBy: "entity-db-cli",
  },
};
